import { render, staticRenderFns } from "./widget-stat-chart2.vue?vue&type=template&id=214a8521&"
import script from "./widget-stat-chart2.vue?vue&type=script&lang=js&"
export * from "./widget-stat-chart2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports